import type { RegisterProps } from "../data-types";

type Props = {
  className?: string;
  registerProps: RegisterProps;
  min?: string;
  max?: string;
};

export default function DatePicker({
  className,
  registerProps,
  ...rest
}: Props) {
  return (
    <input
      className={`kup-input-text ${className}`}
      type="date"
      id={registerProps["name"]}
      {...registerProps}
      {...rest}
    />
  );
}
